import { createApi } from '@reduxjs/toolkit/query/react';
import { ogBaseQuery } from '../../ogBaseQuery';
import { type LbLegalsType } from '../legals.types';

export const legalsOGService = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'legalsOG',
  tagTypes: ['legal'],
  endpoints: (builder) => ({
    getLegal: builder.query<LbLegalsType | undefined, { userId: string }>({
      query: (data) => ({
        url: `users/${data.userId}/legals`,
        method: 'GET',
        params: {
          filter: JSON.stringify({
            include: 'document',
            limit: 1,
          }),
        },
      }),
      providesTags: ['legal'],
      transformResponse: (response: LbLegalsType[]): LbLegalsType | undefined =>
        response[0],
    }),
    generateBaa: builder.mutation<undefined, LbLegalsType>({
      query: (data) => ({
        url: `legals/createBaa`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['legal'],
    }),
    deleteBaa: builder.mutation<undefined, { id: number }>({
      query: (data) => ({
        url: `legals/${data.id}/deleteBaa`,
        method: 'POST',
      }),
      invalidatesTags: ['legal'],
    }),
    getTemporaryUrl: builder.query<
      { url: string },
      { id: string; fileName?: string }
    >({
      query: (data) => {
        const params =
          data.fileName !== undefined ? { download: data.fileName } : {};

        return {
          url: `documents/${data.id}/temporaryUrl`,
          method: 'GET',
          params,
        };
      },
    }),
  }),
});

export const {
  endpoints: { getLegal, generateBaa, deleteBaa, getTemporaryUrl },
  useGetLegalQuery,
  useGenerateBaaMutation,
  useDeleteBaaMutation,
  useLazyGetTemporaryUrlQuery,
} = legalsOGService;
